import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const placeApi = createApi({
  reducerPath: 'placeApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Place'],
  endpoints: (builder) => ({
    getPlaces: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/place',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['Place'],
    }),
    addPlace: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/add-place',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Place'],
    }),
    updatePlace: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/update-place',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Place'],
    }),
    deletePlace: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/delete-place',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Place'],
    }),
  }),
});

export const {
  useGetPlacesQuery,
  useAddPlaceMutation,
  useUpdatePlaceMutation,
  useDeletePlaceMutation,
} = placeApi;
